import { render, staticRenderFns } from "./pickingRules.vue?vue&type=template&id=74b6018a&scoped=true"
import script from "./pickingRules.vue?vue&type=script&lang=js"
export * from "./pickingRules.vue?vue&type=script&lang=js"
import style0 from "./pickingRules.vue?vue&type=style&index=0&id=74b6018a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6018a",
  null
  
)

export default component.exports